import DefaultImage from '../DefaultImage' ;

export default function PartnerImage(props) {
    const {id, shop, form, onClick, className} = props;

    if (shop) return <DefaultImage className={className} onClick={onClick} image={`modules/partners/${id}/${shop}/logo.jpg`}/>
    if (form) return <DefaultImage className={className} onClick={onClick} image={`modules/partners/${id}/${form}/logo.jpg`}/>
}
